
export default function BoostIcon( {className}:{className?:string}) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="17"
			height="16"
			className={className}
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="8.49782" cy="7.99782" r="6.09157" fill="#96FF43" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16ZM11.79 7.56514L9.17049 7.09764L10.8921 3.14121C11.0195 2.87282 10.6902 2.65176 10.4913 2.84173L5.09264 7.98582C4.91791 8.14157 5.01214 8.39613 5.21119 8.43123L7.83394 8.89369L6.10938 12.8544C5.98163 13.1227 6.31112 13.3439 6.50998 13.154L11.9213 7.99765L11.9211 7.99733C12.0692 7.85582 11.9958 7.60171 11.79 7.56514Z"
				fill="#131313"
			/>
		</svg>
	);
}
